import { ReasonFormType } from 'components/reasons/ReasonForm';

export const updateReasonInitialValues: Partial<ReasonFormType> = {};
